export default __webpack_public_path__ + "static/media/arrow_drop_down.77f05835.svg";